import React, { useEffect } from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { EndorseOption } from 'constants/models/endorseOption';
import { EndorseOptContent, EndorseOptContentTarget } from 'bff/models/member';
import { EndorseAttachmentType } from 'constants/enums/endorseAttachmentType';
import { EndorseType } from 'constants/enums/endorseType';
import { Marriage } from 'constants/enums/marriage.enum';
import { EndorseTarget } from 'constants/enums/endorseTarget.enum';
import commonService from 'utils/commonService';

const PreviewVehicle: React.FC<IProps> = (props) => {
    /**
     * 建立變更項目區塊
     */
    const handleCreateItems = () => {
        if (!props.editedEndorseItems || props.editedEndorseItems.length === 0) return;

        const editItems = _.filter(props.editedEndorseItems, (item: EndorseOption) => item.CHECKED);
        if (!editItems || editItems.length === 0) return;

        let titleClass = "correction-preview__correction-content-item-title";

        return _.map(editItems, (editItem: EndorseOption, editItemIndex: number) => {
            // 原始項目
            const originalItem = _.find(props.originalEndorse.OPTION,
                (opt: EndorseOptContent) =>
                    opt.ORDER_NO === editItem.ORDER_NO &&
                    opt.ENDORSE_TYPE === editItem.ENDORSE_TYPE &&
                    opt.DATA_TYPE === editItem.DATA_TYPE
            );

            if (!originalItem) return;

            if (editItemIndex > 0) {
                titleClass = "correction-preview__correction-content-item-mobile-title";
            }

            return (
                <div className="correction-preview__correction-content" key={editItemIndex}>
                    <div className="correction-preview__correction-content-title">{commonService.htmlParser(`${editItem.ORDER_NO}.${editItem.TYPE_NAME}`)}</div>
                    <div className="correction-preview__correction-content-item">
                        <div className="correction-preview__correction-content-item-content">
                            <p className={titleClass}>修改前</p>
                            <div>{handleGetOriginaItemlVal(originalItem)}</div>
                        </div>
                        <div className="correction-preview__correction-content-item-content">
                            <p className={titleClass}>修改後</p>
                            <div>{commonService.htmlParser(handleGetEditItemVal(editItem, originalItem))}</div>
                            {
                                editItem.ATTACHMENT === EndorseAttachmentType.Required && (
                                    <img src={editItem.FILE_BASE64} alt={editItem.TYPE_NAME} />
                                )
                            }
                        </div>
                    </div>
                </div>
            )
        })
    }

    /**
     * @description 取得變更項目內容值
     */
    const handleGetEditItemVal = (editItem: EndorseOption, orginalItem: EndorseOptContent) => {
        switch (editItem.ENDORSE_TYPE) {
            case EndorseType.CONTACT_MOBILE:
                return handleFormatItem(editItem.MOBILE, orginalItem.TARGET, EndorseTarget.APPLICANT_MOBILE);
            case EndorseType.CONTACT_EMAIL:
                return handleFormatItem(editItem.EMAIL, orginalItem.TARGET, EndorseTarget.APPLICANT_EMAIL);
            case EndorseType.NAME:
                return handleFormatItem(editItem.NAME, orginalItem.TARGET, EndorseTarget.INSURED_NAME);
            case EndorseType.ENGINE_ID:
                return handleFormatItem(editItem.ENGINE_ID, orginalItem.TARGET, EndorseTarget.ENGINE_ID);
            case EndorseType.VEHICLE_ID:
                return handleFormatItem(editItem.VEHICLE_ID, orginalItem.TARGET, EndorseTarget.VEHICLE_ID);
            case EndorseType.CAR_LICENSE: {
                const carLicense = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CAR_LICENSE);

                const oriFront = carLicense.replace(/([A-Za-z\d]{0,4})-([A-Za-z\d]{0,4})/, '$1');
                const oriBack = carLicense.replace(/([A-Za-z\d]{0,4})-([A-Za-z\d]{0,4})/, '$2');

                let res = handleBaseFormatItem(editItem.CAR_LICENSE_FRONT, oriFront);
                return `${res}-${handleBaseFormatItem(editItem.CAR_LICENSE_BACK, oriBack)}`
            }
            case EndorseType.MARRIAGE_STATUS: {
                const oriMarriage = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.APPLICANT_MARRIAGE_CODE);
                const oriVal = oriMarriage === Marriage.Single
                    ? '未婚'
                    : oriMarriage === Marriage.Married
                        ? '已婚'
                        : '';
                const curVal = editItem.MARRIAGE === Marriage.Single ? '未婚' : '已婚';
                return handleBaseFormatItem(curVal, oriVal);
            }
            case EndorseType.ISSUE_DATE: {
                const issueDate = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ISSUE_DATE);
                const oriyear = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$1');
                const orimonth = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$2');
                const oridate = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$3');

                return `${handleBaseFormatItem(`${+editItem.ISSUE_DATE_YEAR}`, `${+oriyear}`)}年${handleBaseFormatItem(`${+editItem.ISSUE_DATE_MONTH}`, `${+orimonth}`)}月${handleBaseFormatItem(`${+editItem.ISSUE_DATE_DATE}`, `${+oridate}`)}日`;
            }
            case EndorseType.CONTACT_ADDRESS: {
                const oriCityName = commonService.getCityName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.APPLICANT_CITY_ID));
                const oriAreaName = commonService.getAreaName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.APPLICANT_CITY_ID), handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.APPLICANT_AREA_ID));
                const oriAddress = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.APPLICANT_ADDRESS);

                return `${handleBaseFormatItem(editItem.CITY_ID_NAME, oriCityName)}${handleBaseFormatItem(editItem.AREA_ID_NAME, oriAreaName)}${handleBaseFormatItem(editItem.ADDRESS, oriAddress)}`;
            }
            case EndorseType.RE_SEND_COMPULSORY: {
                const oriCityName = commonService.getCityName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID));
                const oriAreaName = commonService.getAreaName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.AREA_ID));
                const oriAddress = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS);

                return `${handleBaseFormatItem(editItem.CITY_ID_NAME, oriCityName)}${handleBaseFormatItem(editItem.AREA_ID_NAME, oriAreaName)}${handleBaseFormatItem(editItem.ADDRESS, oriAddress)}`;
            }
            default:
                return '';
        }
    }

    /**
     * @description 判斷是否更改值，格式化欄位
     */
    const handleFormatItem = (val: string, targets: EndorseOptContentTarget[], targetType: string) => {
        const oriVal = handleGetOriginalVal(targets, targetType);
        return handleBaseFormatItem(val, oriVal);
    }

    /**  
     * @description 比較兩字串是否一樣，格式化欄位
    */
    const handleBaseFormatItem = (curVal: string, oriVal: string) => {
        if (curVal !== oriVal) return `<span class='edit-item'>${curVal}</span>`

        return curVal;
    }

    /**
     * @description 取得未更改前的值
     */
    const handleGetOriginaItemlVal = (item: EndorseOptContent) => {
        switch (item.ENDORSE_TYPE) {
            case EndorseType.CONTACT_ADDRESS:
                return `
                ${commonService.getCityName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_CITY_ID))}
                ${commonService.getAreaName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_CITY_ID), handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_AREA_ID))}
                ${handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_ADDRESS)}`;
            case EndorseType.CONTACT_EMAIL:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_EMAIL);
            case EndorseType.CONTACT_MOBILE:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_MOBILE);
            case EndorseType.MARRIAGE_STATUS: {
                const val = handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_MARRIAGE_CODE);
                return val === Marriage.Single
                    ? '未婚'
                    : val === Marriage.Married
                        ? '已婚'
                        : '';
            }
            case EndorseType.RE_SEND_COMPULSORY:
                return `
                ${commonService.getCityName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID))}
                ${commonService.getAreaName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(item.TARGET, EndorseTarget.AREA_ID))}
                ${handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS)}`;
            case EndorseType.NAME:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_NAME);
            case EndorseType.ENGINE_ID:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.ENGINE_ID);
            case EndorseType.VEHICLE_ID:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.VEHICLE_ID);
            case EndorseType.CAR_LICENSE:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.CAR_LICENSE);
            case EndorseType.ISSUE_DATE: {
                const issueDate = handleGetOriginalVal(item.TARGET, EndorseTarget.ISSUE_DATE);
                const issueDate_year = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$1');
                const issueDate_month = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$2');
                const issueDate_date = issueDate.replace(/([\d]{0,3})([\d]{2})([\d]{2})/, '$3');
                return `${+issueDate_year}年${+issueDate_month}月${+issueDate_date}日`;
            }
            default:
                return '';
        }
    }

    /**
     * @description 取得項目原始資料值
     */
    const handleGetOriginalVal = (targets: EndorseOptContentTarget[], targetType: string) => {
        return _.find(targets,
            (target: EndorseOptContentTarget) => target.ENDORSE_TARGET === targetType)?.ORG_VALUE || '';
    };

    return (
        <div className="correction-preview__correction-container">
            {
                handleCreateItems()
            }
        </div>
    )
}

export default PreviewVehicle;